import { ChevronRight } from 'lucide-react';
import { focusRings } from 'v5/design-system/_common/focusRing';
import { cn } from 'v5/platform/dom/cn';
import type { UnitFold } from './schemaForm.types';

/**
 * A unit's title that folds the unit away: after it, a chevron pointing
 * down when open, right when folded, and folded, `summary` (a list's count).
 */
export function UnitFoldTitle({
  title,
  fold,
  summary
}: {
  title: string;
  fold: UnitFold;
  summary?: string;
}) {
  return (
    <button
      type="button"
      aria-expanded={!fold.collapsed}
      // Opens in place: the unit around it doesn't light up as if hovered.
      data-expand-target="inline"
      onClick={() => fold.setCollapsed(!fold.collapsed)}
      className={cn(
        'flex max-w-full min-w-0 items-center gap-1 rounded hocus:text-fg-default',
        focusRings.focus.visible
      )}
    >
      <span className="truncate">{title}</span>
      {fold.collapsed && summary !== undefined && (
        <span className="shrink-0 tabular-nums">· {summary}</span>
      )}
      <ChevronRight
        aria-hidden
        className={cn(
          'size-3.5 shrink-0 transition-transform duration-200',
          !fold.collapsed && 'rotate-[90deg]'
        )}
      />
    </button>
  );
}
